import { formatarDigitacaoMoeda } from '../lib/moeda'

// ▶ O que os campos de preço mostram ao ENTRAR no modo de edição, ou ao trocar
// de tabela editando. Até 03/09/2026 o campo sempre começava em branco e só um
// aviso do lado dizia "atual: R$ 6,06" -- ela pediu, no primeiro teste real no
// celular, que o valor apareça DENTRO do campo, pronto para editar, em vez de
// fora como aviso.
export interface RascunhoDePreco {
  preco: string
  avulso: string
  minima: string
  maxima: string
}

// ⭐ Pedido dela no 2o teste real, 03/09: "se na tabela nao tiver valor
// unitario, deixar 0 mas permitir ser editado". O avulso e o UNICO campo
// deste rascunho que comeca preenchido mesmo sem dado -- salvar sem tocar
// grava `preco_unidade: null` (a mesma coisa que ja acontecia com o campo em
// branco antes de 03/09, so que agora visivel na tela em vez de escondida).
const RASCUNHO_VAZIO: RascunhoDePreco = { preco: '', avulso: '0,00', minima: '', maxima: '' }

export function rascunhoDePrecoAoEditar(
  linha:
    | {
        preco?: number | null
        preco_unidade?: number | null
        quantidade_minima?: number | null
        quantidade_maxima?: number | null
      }
    | undefined,
): RascunhoDePreco {
  if (!linha) return RASCUNHO_VAZIO
  return {
    // `!= null` de propósito: pega null E undefined -- a linha de precos em
    // cache de antes da 0018/0021 não tem todas as chaves.
    preco: linha.preco != null ? formatarDigitacaoMoeda(String(linha.preco)) : '',
    avulso: linha.preco_unidade != null ? formatarDigitacaoMoeda(String(linha.preco_unidade)) : '0,00',
    minima: linha.quantidade_minima != null ? String(linha.quantidade_minima) : '',
    maxima: linha.quantidade_maxima != null ? String(linha.quantidade_maxima) : '',
  }
}
